// extracted by mini-css-extract-plugin
export default {"ButtonSection":"gridOcorrencia_ButtonSection__TiJj-","UlCuston":"gridOcorrencia_UlCuston__Rd4qN"};